/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { media } from '@atlassian/bitkit-responsive';

// This is applied to make sure there is still a top margin
// when filer items get wrapped.
const FILTER_TOP_MARGIN = gridSize();

export const FiltersContainer = styled.div({
  display: 'flex',
  marginBottom: `${gridSize() * 2}px`,
  alignItems: 'center',
  flexWrap: 'wrap',
  marginTop: `-${FILTER_TOP_MARGIN}px`,
});

export const FilterItem = styled.div<{ isReducedFilterPadding?: boolean }>`
  margin-top: ${FILTER_TOP_MARGIN}px;
  &:not(:empty) {
    padding-right: ${props =>
      props.isReducedFilterPadding ? `${gridSize()}px` : `${gridSize() * 2}px`};
  }
`;

export const TextFilterItem = styled(FilterItem)({
  '&&&': media.upToSmall(`
    width: 100%;
    padding-right: 0;
  `),
});
